import { TIcon } from "@/app/types/types";

const DownloadIcon = ({ color }: TIcon) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 15.1L5.04167 10.1417L5.9625 9.22083L9.3625 12.6208V0.0833327H10.6375V12.6208L14.0375 9.22083L14.9583 10.1417L10 15.1ZM2.24375 19.9167C1.62986 19.9167 1.11042 19.716 0.685417 19.3146C0.284028 18.8896 0.0833337 18.3701 0.0833337 17.7562V14.1792H1.35833V17.7562C1.35833 17.9687 1.45278 18.1694 1.64167 18.3583C1.83056 18.5472 2.03125 18.6417 2.24375 18.6417H17.7563C17.9688 18.6417 18.1694 18.5472 18.3583 18.3583C18.5472 18.1694 18.6417 17.9687 18.6417 17.7562V14.1792H19.9167V17.7562C19.9167 18.3701 19.7042 18.8896 19.2792 19.3146C18.8778 19.716 18.3701 19.9167 17.7563 19.9167H2.24375Z"
        fill={color}
      />
    </svg>
  );
};

export default DownloadIcon;
